import { get, post } from "./api";
import type {
  AssignFollowerRequest,
  CreateCoachFromFollowerRequest,
  TwitterFollowerPage,
  TwitterFollowerResponse,
} from "../types/crm";

export const getFollowers = (
  connectorId?: string,
  pageNumber = 1,
  pageSize = 20
): Promise<TwitterFollowerPage> => {
  const params = new URLSearchParams({
    pageNumber: String(pageNumber),
    pageSize: String(pageSize),
  });
  if (connectorId) params.set("connectorId", connectorId);
  return get(`/api/crm/twitter/followers?${params}`);
};

export const createContactFromFollower = (
  id: string,
  request: CreateCoachFromFollowerRequest
): Promise<TwitterFollowerResponse> =>
  post(`/api/crm/twitter/followers/${id}/create-contact`, request);

export const assignFollowerToCoach = (
  id: string,
  request: AssignFollowerRequest
): Promise<void> =>
  post(`/api/crm/twitter/followers/${id}/assign-contact`, request);

export const importFollowers = (): Promise<void> =>
  post("/api/crm/twitter/import-followers", {});
